import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LeadType } from 'src/app/_enums/lead-type.enum';

@Component({
  selector: 'app-lead-button',
  templateUrl: './button-lead.component.html',
})
export class ButtonLeadComponent implements ICellRendererAngularComp {
  @Input()
  params!: ICellRendererParams;

  LeadType = LeadType;

  constructor() {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams) {
    return false;
  }

  openCustomerSupportModal() {
    this.params.context.componentParent.AssignCustomerSupportModal(this.params);
  }
}
